export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LOGIN_OTP_LENGTH = 6;

export const RESEND_OTP_COOLDOWN_SEC = 60;

export const OTP_INVALID_MESSAGE =
    "Invalid or expired verification code. Please try again.";

export const OTP_VERIFY_FAILED_MESSAGE = "Unable to verify the code. Please try again.";

export const OTP_SENT_SUCCESS_MESSAGE = "Verification code sent successfully.";
export const OTP_RESENT_SUCCESS_MESSAGE = "Verification code resent successfully.";
export const OTP_SEND_FAILED_MESSAGE =
    "Unable to send a verification code. Please check your email and try again.";
export const OTP_RESEND_FAILED_MESSAGE =
    "Unable to resend the verification code. Please try again.";
export const OTP_SEND_NETWORK_ERROR_MESSAGE =
    "Unable to sign in right now. Please try again later.";
